import React from "react";

// locales
import i18n from '../../i18n';
// the hoc
import { withTranslation } from 'react-i18next';

// vars
// import { THEME_ARRAY } from "../../utils/const";

// components
import SelectApplyBtn from "./SelectApplyBtn";

// style
import "./SelectTheme.scss";

class SelectTheme extends React.Component {

	// radioArr = THEME_ARRAY;

	constructor(props) {
		super(props);
		this._onclickHandler = props.onClick;
		this.state = {
			radioBtnState: '',
			themeArray: this.props.themeArray,
			themeImgArray: this.props.themeImgArray,
		};
	}


	// ____________________________________ onHandlers ____________________________________

	onRadioChangeHandler(e) {
		const id = e.currentTarget.id;
		this.setState({
			radioBtnState: id,
		});
	}

	onSubmitHandler() {
		this._onclickHandler(this.state.radioBtnState);
	}

	// ____________________________________ render ____________________________________


	render() {
		return (
			<div className="container-select select-theme">
				<div className="row">
					<div className="col-12 col-md-6">

						{/* <h3>{(this.state.radioBtnState === '') ? "Choose theme" : this.state.radioBtnState}</h3> */}

						<div className="select-intro">
							<p>{i18n.t('select.theme.intro')}</p>
							<p className="caption">{i18n.t('select.theme.caption')}</p>
						</div>
					</div>
				</div>

				<div className="row">
					{
						this.state.themeArray.map((value, key) =>
							<div className="col-12 col-sm-6 col-md-4 select-theme-wrapper" key={key}>
								<div className="custom-control custom-radio custom-control-inline">
									<input
										type="radio"
										id={value}
										name="customLocationRadio"
										onChange={(e) => this.onRadioChangeHandler(e)}
										className="custom-control-input"
									/>
									<label className="custom-control-label" htmlFor={value}>
										{value}
										{/* <img src={"https://picsum.photos/seed/" + value + "/120/120"} className="" alt="" /> */}
										<img src={this.state.themeImgArray[value]} className="" alt="" />
									</label>

								</div>
							</div>
						)
					}
				</div>

				<SelectApplyBtn
					isdisabled={this.state.radioBtnState === ''}
					onClick={(e) => this.onSubmitHandler()}
					onApplyClick={(e) => this.props.onApplyClick(e, `${this.props.selectedState}`, `${this.state.radioBtnState}`)}
				/>

			</div>
		);
	}
}

export default withTranslation()(SelectTheme);
